import Modal from "react-bootstrap/Modal";
import {ModalBody, ModalHeader, ModalTitle} from "react-bootstrap";
import ZoomImage from "../ZoomImage";

function MetaphoricCardsPreviewModal(props) {

    function defineCardPosition(index) {
        if (index === 0) {
            return "first"
        } else if (index === 1) {
            return "second"
        } else if (index === 2) {
            return "third"
        } else if ((index % 3) === 0) {
            return "left"
        } else if (((index - 1) % 3) === 0) {
            return "middle"
        } else if (((index - 2) % 3) === 0) {
            return "right"
        }
    }

    function getZoomElement(cardLink, index) {
        return (
            <ZoomImage
                key={index}
                image={
                    <div className={defineCardPosition(index)}
                    >
                        <img src={cardLink}
                             alt={"Not found"}
                             style={{
                                 width: "100%",
                                 height: "100%"
                             }}
                             onContextMenu={(evt) => {evt.preventDefault()}}
                             onDragStart={(event) => {
                                 event.preventDefault()
                                 return false
                             }}
                        ></img>
                    </div>
                }/>
        )
    }

    return (
        <>
            <Modal
                show={true}
                onHide={props.onClose}
                size={"lg"}
            >
                <ModalHeader closeButton>
                    <ModalTitle>{props.name}</ModalTitle>
                </ModalHeader>

                <ModalBody
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gridColumnGap: "12px",
                        gap: "12px",
                        overflowY: "auto",
                        width: "100%"
                    }}
                >
                    {
                        props.cardsLinks.map(
                            (card, index) => {
                                return getZoomElement(card, index)
                            }
                        )
                    }
                </ModalBody>
            </Modal>
        </>
    )

}

export default MetaphoricCardsPreviewModal